// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3u_pW","alertIcon":"ConfirmModal_alertIcon__1VoI6"};